"use strict";
/**
 * @file 一些简单的基础函数
 * @author hedongran
 * @email hdr01@126.com
 */
Object.defineProperty(exports, "__esModule", { value: true });
function isString(str) {
    return Object.prototype.toString.call(str) === '[object String]';
}
exports.default = isString;
;
